import React from "react";
import TopbarDropdown from "../TopbarDropdown/TopbarDropdown";
import TopSearch from "../TopSearch/TopSearch";

const Topbar = () => {

    return (
        <nav className="absolute top-0 right-0 w-full flex items-center h-topbarHeight lg:w-topbarWidth px-4 text-black">
            {/* <TopSearch /> */}
            <TopbarDropdown />
        </nav>
    )
};

export default Topbar;
